<template>
  <v-layout align-space-around justify-start fill-height column class="pt-5">
    <v-slide-x-transition>
      <v-card class="ml-4 mr-4 mb-4">
        <v-card-text>
          <v-layout wrap align-center>
            <v-flex xs12 class="subheading grey--text mb-3">
              Postos que devem repassar os valores de taxas de serviço cobradas dos usuários.
            </v-flex>
            <v-flex xs12 sm6 md3 class="pr-2">
              <v-select
                v-model="mesSelecionado"
                :items="meses"
                label="Mês"
                clearable
                @change="carregarRelatorio"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 class="pr-2">
              <v-select
                v-model="anoSelecionado"
                :items="anos"
                label="Ano"
                clearable
                @change="carregarRelatorio"
              ></v-select>
            </v-flex>
            <v-flex xs2 md1 align-self-center>
              <v-btn fab small color="info" @click="carregarRelatorio">
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-slide-x-transition>

    <v-data-table
      :headers="headers"
      :items="relatorio"
      :loading="loading"
      hide-actions
      :hide-headers="!relatorio || !relatorio.length"
      no-data-text="Nenhum repasse pendente encontrado para este período."
      class="elevation-1 ml-4 mr-4"
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left px-4">{{ props.item.posto }}</td>
          <td class="text-xs-left">{{ props.item.posto__nome_fantasia }}</td>
          <td class="text-xs-left">
            <v-chip
              :color="props.item.posto__is_white_label ? 'primary' : 'default'"
              dark
              small
            >
              {{ props.item.posto__is_white_label ? 'Sim' : 'Não' }}
            </v-chip>
          </td>
          <td class="text-xs-right pr-4">
            <strong>{{ formatarDinheiro(props.item.total_repassar) }}</strong>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div class="text-xs-center">
      <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
    </div>

    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="relatorio.length">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Total a Repassar: {{ formatarDinheiro(totalGeral) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :timeout="4000"
      top
      right
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
export default {
  name: 'RelatorioRepasseTaxas',
  data () {
    return {
      loading: false,
      mesSelecionado: new Date().getMonth() + 1,
      anoSelecionado: new Date().getFullYear(),
      totalGeral: 0,
      totalItens: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      snackbar: {
        active: false,
        text: '',
        color: 'error'
      },
      meses: [
        { text: 'Janeiro', value: 1 },
        { text: 'Fevereiro', value: 2 },
        { text: 'Março', value: 3 },
        { text: 'Abril', value: 4 },
        { text: 'Maio', value: 5 },
        { text: 'Junho', value: 6 },
        { text: 'Julho', value: 7 },
        { text: 'Agosto', value: 8 },
        { text: 'Setembro', value: 9 },
        { text: 'Outubro', value: 10 },
        { text: 'Novembro', value: 11 },
        { text: 'Dezembro', value: 12 }
      ],
      anos: [2023, 2024, 2025, 2026, 2027],
      relatorio: [],
      headers: [
        { text: 'ID Posto', value: 'posto', align: 'left', class: 'px-4' },
        { text: 'Nome do Posto', value: 'posto__nome_fantasia', align: 'left' },
        { text: 'Whitelabel', value: 'posto__is_white_label', align: 'left', sortable: false },
        { text: 'Total a Repassar', value: 'total_repassar', align: 'right', class: 'pr-4' }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItens == null) return 0
      return Math.ceil(this.totalItens / this.pagination.rowsPerPage)
    }
  },
  mounted () {
    this.carregarRelatorio()
  },
  methods: {
    formatarDinheiro (valor) {
      if (!valor) return 'R$ 0,00'
      return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    async carregarRelatorio () {
      this.loading = true
      try {
        const data = await this.$store.dispatch('relatorioRepasseTaxas', {
          mes: this.mesSelecionado,
          ano: this.anoSelecionado
        })
        this.relatorio = data
        this.totalItens = data.length
        this.totalGeral = data.reduce((acc, item) => acc + Number(item.total_repassar || 0), 0)
      } catch (error) {
        this.snackbar.text = 'Não foi possível carregar o relatório.'
        this.snackbar.color = 'error'
        this.snackbar.active = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
</style>
